import React from 'react';
import {Col, Row, Tab, Table, Tabs} from "react-bootstrap";
import {standartBody, standartHead} from "./standartRacoonTable";
import {showCount} from "../../../helpers/showCount";
import moment from "moment";
import numberFormat from "../../../helpers/numberFormat";
import _ from "lodash"

const KayarTransaviaRender = ({data}) => {
  console.log("transdata", data)
  const {revise, kayarServices, transaviaServices} = data

  return (
    <>
      <Row>
        <Col>
          <Tabs defaultActiveKey="correct">
            <Tab
              eventKey="correct"
              title={`Правильные (${revise.correct.length})`}
            >
              <Table striped hover>
                {standartHead()}
                {standartBody(revise.correct)}
              </Table>
            </Tab>
            <Tab
              eventKey="noSilk"
              title={`Есть в Kayar но нет в Трансавии (${showCount(revise.transaviaMissing)})`}
            >
              <Table striped hover>
                {standartHead()}
                {standartBody(revise.transaviaMissing)}
              </Table>
            </Tab>
            <Tab
              eventKey="noKayar"
              title={`Есть в Трансавии но нет в Kayar (${showCount(revise.kayarMissing)})`}
            >
              <Table striped hover>
                {standartHead()}
                {standartBody(revise.kayarMissing)}
              </Table>
            </Tab>
            <Tab
              eventKey="diff"
              title={`Не соответствуют (${showCount(revise.diff)})`}
            >
              <Table striped hover>
                <thead>
                <tr>
                  <td>Номер</td>
                  <td>Выписан Kayar</td>
                  <td>Выписан Трансавиа</td>
                  <td>Итого Kayar</td>
                  <td>Итого Трансавиа</td>
                </tr>
                </thead>
                <tbody>
                {revise.diff.map((u, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {u.airline} {u.ticketNumber}
                      </td>
                      <td>{moment.utc(u.kayarIssueDate).format("DD.MM.YYYY")}</td>
                      <td>{moment.utc(u.issueDate).format("DD.MM.YYYY")}</td>
                      <td>{numberFormat(u.total.kayar)}</td>
                      <td>{numberFormat(u.total.transavia)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={3}>
                    <b>Итого</b>
                  </td>
                  <td>
                    <b>
                      {numberFormat(
                        revise.diff
                          .map(u => u.total.kayar)
                          .reduce((a, b) => a + b, 0)
                      )}
                    </b>
                  </td>
                  <td>
                    <b>
                      {numberFormat(
                        revise.diff.map(u => u.total.transavia).reduce((a, b) => a + b, 0)
                      )}
                    </b>
                  </td>
                </tr>
                </tbody>
              </Table>
            </Tab>
            <Tab
              eventKey="services"
              title={`Тур-услуги`}
            >
              <Row>
                <Col>
                  {renderServiceTable(`Услуги в Трансавии - ${transaviaServices.length}`,transaviaServices)}
                </Col>
                <Col>
                  {renderServiceTable(`Услуги в Kayar - ${kayarServices.length}`,kayarServices)}
                </Col>
              </Row>
              <Row >
                <Col>
                  <h3>Итого Трансавия: {numberFormat(_.sumBy(transaviaServices, 'total'))}</h3>
                </Col>
                <Col>
                  <h3>Итого Каяр: {numberFormat(_.sumBy(kayarServices, 'total'))}</h3>
                </Col>
              </Row>
              <h3>Разница: {numberFormat(_.sumBy(transaviaServices, 'total') - _.sumBy(kayarServices, 'total'))}</h3>
            </Tab>
          </Tabs>
        </Col>
      </Row>

    </>
  );
};

export default KayarTransaviaRender;

const renderServiceTable = (name, array) =>{
  return <Table striped hover>
    <thead>
    <tr align={'center'}>
      <td colSpan={3}>{name}</td>
    </tr>
    <tr>
      <td>Услуга</td>
      <td>Пассажир</td>
      <td>Сумма</td>
    </tr>
    </thead>
    <tbody>
    {array.map((row,index)=>{
      return <tr key={index}>
        <td>{row.name}</td>
        <td>{row.pax}</td>
        <td>{row.total}</td>
      </tr>
    })}
    </tbody>
  </Table>
}
